const windowAroundValue = (val: number, windowSize: number, min: number, max: number): number[] => {
  let startAt = val - Math.floor(windowSize / 2)
  if (startAt + windowSize > max) { startAt = max - windowSize + 1}
  if (startAt < min) { startAt = min }
  const res: number[] = []
  for (let i = 0; i < windowSize; i++) {
    if (startAt + i <= max) { res.push(startAt + i) }
  }
  return res
}

export default windowAroundValue
